/**
 * Author Morakot Maneelert
 * @param {*} url 
 */

const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
    image.onload = function () {
      // let img_width = 0
      // let img_height = 0
      if(image.width > 500) {
        //img_width = 500
        image.width = 500
      } else {
        //img_width = image.width
       // image.width = image.width
      }

      if(image.height > 500) {
        // img_height = 500
        image.height = 500
      } else {
        // img_height = image.height
        //image.height = image.height
      }
      
      // console.log("Original width: " + image.width + "px")
      // console.log("Original height: " + image.height + "px")
    }
  })

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180
}

/**
 *
 * @param {File} image
 * @param {Object} pixelCrop
 * @param {number} rotation 
 */
export default async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const maxSize = Math.max(image.width, image.height)
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))

  // ตั้งค่าแต่ละมิติเป็นสองมิติที่ใหญ่ที่สุดเพื่อให้มีพื้นที่ปลอดภัยสำหรับ
  // รูปภาพที่จะหมุนโดยไม่ถูกตัดโดยบริบทผ้าใบ
  canvas.width = safeArea
  canvas.height = safeArea

  ctx.translate(safeArea / 2, safeArea / 2)
  ctx.rotate(getRadianAngle(rotation))
  ctx.translate(-safeArea / 2, -safeArea / 2)

  // วาดภาพหมุนและจัดเก็บข้อมูล
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  )
  const data = ctx.getImageData(0, 0, safeArea, safeArea)

  
  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  // วางภาพหมุนที่สร้างขึ้นพร้อมออฟเซ็ตที่ถูกต้องสำหรับค่า x, y ครอบตัด
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
  )

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise(resolve => {
    var dataURL = canvas.toDataURL();
    resolve(dataURL)
    // canvas.toDataURL(file => {
    //   resolve(URL.createObjectURL(file))
    // }, 'image/jpeg')
  })
}
